import styled, { css } from 'styled-components'

export const WrapperTabler = styled.div`
  margin-top: 1rem;
`

export const Definitions = styled.div`
  margin-top: 1rem;

  p {
    margin: 0;
    padding: 0;
  }
`
